import { apiGet, apiPost, apiPostMultipart, apiPut, apiDelete } from 'helpers/ApiHelper';
import { toISO8601DateString, objectToQuery } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';

import Auth from 'j-toker';
import * as notifications from './notificationActions';
import * as todoActions from './todoActions';
import * as downloadActions from './downloadActions';
import { getTenancyStatus } from 'actions/dashboardActions';
import { dispatchPayloadAction } from './simpleActions';
import { hideInitialLeadDialog, getUserPreferences } from 'actions/userTypesActions';
import { reset } from 'redux-form';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { getTranslatedString } from 'helpers/i18n';
import { logUserOut } from 'actions/authenticationActions';
import { featureEnabled } from 'helpers/ToggleBot';

function saveTenantProfile(response) {
  let birthday = Date();
  if (response.generalDetails.birthday) {
    birthday = moment(response.generalDetails.birthday).toDate();
  }
  return {
    type: 'GET_TENANT_PROFILE',
    generalDetails: response.generalDetails,
    emergencyContacts: response.emergency_contacts,
    birthday: birthday,
  };
}

export function getTenantProfile() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/profile')
        .done(response => {
          dispatch(saveTenantProfile(response));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function updatePadDetails(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/pad_details', formData)
        .done(response => {
          dispatch(notifications.showSuccess());
          dispatch(getTenancyStatus());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          return error;
        }),
    });
  };
}

export function PADDetails(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/pad_details', formData)
        .done(response => {
          dispatch(notifications.showSuccess());
          dispatch(getTenancyStatus());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          return error;
        }),
    });
  };
}

export function updatePadDetailSettings(authorizedAmount, payTotalAmount) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/leads/pad_details/settings`, {
        authorized_amount: authorizedAmount,
        pay_total_amount: payTotalAmount,
      })
        .done(response => {
          return dispatch(notifications.showSuccess('landlordPortal.papForm.update.success'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deletePADDetails() {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/pad_details')
        .done(response => {
          dispatch(notifications.showSuccess('successfullyDeletedPAPDetails'));
          dispatch(getTenancyStatus());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          return error;
        }),
    });
  };
}

export function createExternalAutopay(formData) {
  const multiPartFormData = new FormData();
  multiPartFormData.append('void_cheque_image', formData.voidChequeImage[0]);
  multiPartFormData.append('image_name', formData.voidChequeImage[0].name);
  multiPartFormData.append('image_content_type', formData.voidChequeImage[0].type);
  multiPartFormData.append('institution_number', formData.institution_number);
  multiPartFormData.append('account_number', formData.account_number);
  multiPartFormData.append('transit_number', formData.transit_number);
  multiPartFormData.append('autopay_start_date', formData.autopay_start_date);
  if (featureEnabled('external_autopay')) {
    multiPartFormData.append('partial_or_total_amount', formData.partial_or_total_amount);
    if (formData.partial_monthly_amount) {
      multiPartFormData.append('partial_monthly_amount', formData.partial_monthly_amount);
      multiPartFormData.append(
        'apply_partial_monthly_amount_to',
        formData.apply_partial_monthly_amount_to
      );
    }
  }

  return dispatch => {
    return dispatch({
      payload: apiPostMultipart(
        Auth.getApiUrl() + '/leads/create_external_autopay',
        multiPartFormData
      )
        .done(response => {
          if (!featureEnabled('external_autopay')) {
            dispatch(notifications.showSuccess());
          }
          dispatch(getTenancyStatus());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          return error;
        }),
    });
  };
}

export function postUserProfileDetails(data) {
  return dispatch => {
    if (data.new_document) {
      // upload new tenant document
      const multiPartFormData = new FormData();
      multiPartFormData.append('file', data.new_document.file[0]);
      multiPartFormData.append('document_type', data.new_document.document_type);
      const document_sub_type =
        data.new_document.document_sub_type || data.new_document.document_sub_type_name;
      multiPartFormData.append('document_sub_type', document_sub_type);

      return dispatch({
        payload: apiPostMultipart(Auth.getApiUrl() + '/leads/documents', multiPartFormData)
          .done(response => {
            dispatch(getTenantProfile());
            dispatch(notifications.showSuccess());
          })
          .catch(error => {
            console.error('request failed', error);
            dispatch(notifications.showFailure(error));
          }),
      });
    }

    data['birthday'] = toISO8601DateString(data['dob']);

    if (data['full_name']) {
      data['first_name'] = data['full_name'].split(' ')[0];
      data['last_name'] = data['full_name'].split(' ')[1];
    }

    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/update_general_profile_details', data)
        .done(response => {
          dispatch(getTenantProfile());
          dispatch(notifications.showSuccess('successfullyUpdated'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function postProfilePhoto(file) {
  return dispatch => {
    const multiPartFormData = new FormData();
    multiPartFormData.append('profile_photo', file);

    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + '/leads/profile_photo', multiPartFormData)
        .done(response => {
          dispatch(getTenantProfile());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function updateAssistanceRequest(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/update_assistance_request', formData)
        .done(response => {
          dispatch(getTenantProfile());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

function displayRentalHistoryQuestions(response) {
  // yes/no mapping so redux can initialize correctly
  response.eviction = response.eviction ? 'yes' : 'no';
  response.bankruptcy = response.bankruptcy ? 'yes' : 'no';
  response.court = response.court ? 'yes' : 'no';
  response.felony = response.felony ? 'yes' : 'no';
  response.hearing = response.hearing ? 'yes' : 'no';
  return {
    type: 'DISPLAY_TENANT_RENTAL_HISTORY_QUESTIONS',
    questions: response,
  };
}

export function getTenantRentalHistoryQuestions() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/rental_history_questions')
        .done(response => {
          dispatch(displayRentalHistoryQuestions(response));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function putTenantRentalHistoryQuestions(data) {
  // yes/no unmapping so it can be updated correctly
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.eviction = data.eviction === 'yes';
  data_clone.bankruptcy = data.bankruptcy === 'yes';
  data_clone.court = data.court === 'yes';
  data_clone.felony = data.felony === 'yes';
  data_clone.hearing = data.hearing === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/rental_history_questions', data_clone)
        .done(response => {
          dispatch(getTenantRentalHistoryQuestions());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

function displayLandlordReferences(response) {
  return {
    type: 'DISPLAY_LANDLORD_REFERENCES',
    landlord_references: response,
  };
}

export function getLandlordReferences() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/landlord_references')
        .done(response => {
          for (let key = 0; key < response.data.length; key++) {
            response.data[key].is_current_reference =
              response.data[key].is_current_reference === true ? 'yes' : 'no';
          }
          dispatch(displayLandlordReferences(response.data));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function putLandlordReferences(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  data_clone.phone_number = data.phone_number.replace(/[()\\s-]+/gi, '');
  data_clone.is_current_reference = data.is_current_reference.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/landlord_references/' + data_clone.id, data_clone)
        .done(response => {
          dispatch(getLandlordReferences());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function postLandlordReferences(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  data_clone.phone_number = data.phone_number.replace(/[()\\s-]+/gi, '');
  data_clone.is_current_reference = data.is_current_reference.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/landlord_references', data_clone)
        .done(response => {
          dispatch(getLandlordReferences());
          dispatch(reset('addLandlordReferenceForm'));
          dispatch(notifications.showSuccess('successfullyAddedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deleteLandlordReference(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/landlord_references/' + id)
        .done(response => {
          dispatch(getLandlordReferences());
          dispatch(notifications.showSuccess('successfullyDeletedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function editLandlordReference(reference) {
  return {
    type: 'EDIT_LANDLORD_REFERENCE',
    reference: reference,
  };
}

// Personal References
function displayPersonalReferences(response) {
  return {
    type: 'DISPLAY_PERSONAL_REFERENCES',
    personal_references: response,
  };
}

export function getPersonalReferences() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/personal_references')
        .done(response => {
          dispatch(displayPersonalReferences(response.data));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function putPersonalReferences(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  data_clone.phone_number = data.phone_number.replace(/[()\\s-]+/gi, '');
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/personal_references/' + data_clone.id, data_clone)
        .done(response => {
          dispatch(getPersonalReferences());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function postPersonalReferences(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  data_clone.phone_number = data.phone_number.replace(/[()\\s-]+/gi, '');
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/personal_references', data_clone)
        .done(response => {
          dispatch(getPersonalReferences());
          dispatch(reset('addPersonalReferenceForm'));
          dispatch(notifications.showSuccess('successfullyAddedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deletePersonalReference(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/personal_references/' + id)
        .done(response => {
          dispatch(getPersonalReferences());
          dispatch(notifications.showSuccess('successfullyDeletedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function editPersonalReference(reference) {
  return {
    type: 'EDIT_PERSONAL_REFERENCE',
    reference: reference,
  };
}

// PreviousEmployment Info
function displayPreviousEmploymentInfo(response) {
  return {
    type: 'DISPLAY_PREVIOUS_EMPLOYMENT_INFO',
    previous_employment_info: response,
  };
}

export function getPreviousEmploymentInfo() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/previous_employment_info')
        .done(response => {
          for (let key = 0; key < response.data.length; key++) {
            response.data[key].is_current_occupation =
              response.data[key].is_current_occupation === true ? 'yes' : 'no';
          }
          dispatch(displayPreviousEmploymentInfo(response.data));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deletePreviousEmploymentInfo(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/previous_employment_info/' + id)
        .done(response => {
          dispatch(getPreviousEmploymentInfo());
          dispatch(notifications.showSuccess('successfullyDeletedEmploymentInformation'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function postPreviousEmploymentInfo(data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.is_current_occupation = data.is_current_occupation.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/previous_employment_info', data_clone)
        .done(response => {
          dispatch(getPreviousEmploymentInfo());
          dispatch(reset('addPreviousEmploymentInfoForm'));
          dispatch(notifications.showSuccess('successfullyAddedEmploymentInformation'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function editPreviousEmploymentInfo(employmentInfoToEdit) {
  employmentInfoToEdit.start_date = new Date(employmentInfoToEdit.start_date);
  employmentInfoToEdit.end_date = new Date(employmentInfoToEdit.end_date);
  return {
    type: 'EDIT_PREVIOUS_EMPLOYMENT_INFO',
    employmentInfoToEdit: employmentInfoToEdit,
  };
}

export function putPreviousEmploymentInfo(data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.is_current_occupation = data.is_current_occupation.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + '/leads/previous_employment_info/' + data.id, data_clone)
        .done(response => {
          dispatch(getPreviousEmploymentInfo());
          dispatch(notifications.showSuccess());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function createRentReceipt(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/rent_receipts', formData)
        .done(response => {
          window.open(response.receipt_url);
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function authorizePayment(token, paymentDetails) {
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
        token: token,
      },
    })
  );
  data_clone.payment_amount = paymentDetails.payment_amount;

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/authorize_payment', data_clone)
        .then(response => {
          dispatch({
            type: 'TENANT_PAYMENTS::DISPLAY_PAYMENT_WITH_FEE',
            paymentWithFee: response.payment_with_fee,
          });
          return true;
        })
        .catch(error => {
          if (
            deepDiver(error, 'responseJSON.bpms_error_message') &&
            deepDiver(error, 'responseJSON.message')
          ) {
            dispatch({
              type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
              error: error.responseJSON,
            });
            return false;
          }

          dispatch({
            type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
            error: error,
          });
          return false;
        }),
    });
  };
}

export function makePayment(token, paymentDetails) {
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
        token: token,
      },
    })
  );
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/payments', data_clone)
        .done(response => {
          const verbiage = `${getTranslatedString(
            'successfullySubmittedPaymentOf'
          )}${' '}${paymentDetails.payment_with_fee.formatted_total}`;
          dispatch({
            type: 'TENANT_PAYMENTS::PAYMENT_SUCCESS',
            paymentSuccessDetails: response.payment_details,
          });
          dispatch(notifications.showSuccess(verbiage));
          return true;
        })
        .catch(error => {
          if (
            deepDiver(error, 'responseJSON.bpms_error_message') &&
            deepDiver(error, 'responseJSON.message')
          ) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON,
            });
            return false;
          }
          if (deepDiver(error, 'responseJSON.paysafe_error_code')) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON.paysafe_error_code,
            });
            return false;
          }
          dispatch({ type: 'TENANT_PAYMENTS::PAYMENT_ERROR', error: error });
          return false;
        }),
    });
  };
}

export function authorizeDirectDebitPayment(paymentDetails) {
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
      },
    })
  );
  data_clone.payment_amount = paymentDetails.payment_amount;

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/payments/authorize_direct_debit', data_clone)
        .then(response => {
          dispatch({
            type: 'TENANT_PAYMENTS::DISPLAY_PAYMENT_WITH_FEE',
            paymentWithFee: response.payment_with_fee,
          });
          return true;
        })
        .catch(error => {
          if (deepDiver(error, 'responseJSON.message')) {
            dispatch({
              type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
              error: error.responseJSON,
            });
            return false;
          }

          dispatch({
            type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
            error: error,
          });
          return false;
        }),
    });
  };
}

export function makeDirectDebitPayment(paymentDetails) {
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
      },
    })
  );
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/payments/direct_debit', data_clone)
        .done(response => {
          const verbiage = `${getTranslatedString(
            'successfullySubmittedPaymentOf'
          )}${' '}${paymentDetails.payment_with_fee.formatted_total}`;
          dispatch({
            type: 'TENANT_PAYMENTS::PAYMENT_SUCCESS',
            paymentSuccessDetails: response.payment_details,
          });
          dispatch(notifications.showSuccess(verbiage));
          return true;
        })
        .catch(error => {
          if (deepDiver(error, 'responseJSON.message')) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON,
            });
            return false;
          }
          if (deepDiver(error, 'responseJSON.paysafe_error_code')) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON.paysafe_error_code,
            });
            return false;
          }
          dispatch({ type: 'TENANT_PAYMENTS::PAYMENT_ERROR', error: error });
          return false;
        }),
    });
  };
}

export function boardwalkPayments(subset = 'all', rangeStartDate = null, rangeEndDate = null) {
  let options = {
    subset: subset,
    range_start_date: rangeStartDate,
    range_end_date: rangeEndDate,
  };

  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/bpms_payments' + objectToQuery(options))
        .done(response => {
          dispatch(getBoardwalkTenantPayments(response.payments));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function getBoardwalkTenantPayments(boardwalkPayments) {
  return {
    type: 'TENANT_DASHBOARD::GET_BOARDWALK_TENANT_PAYMENTS',
    boardwalkPayments,
  };
}

export function payments() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/payments')
        .done(response => {
          dispatch(getTenantPayments(response.payments));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function getTenantPayments(payments) {
  return {
    type: 'TENANT_DASHBOARD::GET_TENANT_PAYMENTS',
    payments,
  };
}

export function getBuildingInformation() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/building')
        .done(response => {
          dispatch(displayBuildingInformation(response.property));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function displayBuildingInformation(building) {
  return {
    type: 'DISPLAY_TENANT_BUILDING',
    building,
  };
}

export function getAmenities() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/amenities')
        .done(response => {
          dispatch(displayAmenities(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deleteTenantDocument(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/self_uploaded_documents/' + id)
        .done(response => {
          dispatch(getTenantProfile());
          dispatch(notifications.showSuccess('successfullyDeletedDocument'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

function displayAmenities({ amenities, amenity_booking_waiver }) {
  return {
    type: 'DISPLAY_AMENITIES',
    amenities,
    amenity_booking_waiver,
  };
}

export function getPromotions() {
  return dispatchPayloadAction(
    () => {
      return apiGet(Auth.getApiUrl() + '/leads/promotions');
    },
    (dispatch, response) => {
      dispatch(displayPromotions(response.promotions));
    }
  );
}

function displayPromotions(promotions) {
  return {
    type: 'DISPLAY_PROMOTIONS',
    promotions,
  };
}

export function getProperties() {
  return dispatchPayloadAction(
    () => apiGet(Auth.getApiUrl() + '/leads/properties'),
    (dispatch, response) =>
      dispatch({
        type: 'DISPLAY_PROPERTIES',
        properties: response.properties,
      })
  );
}

export function getReferrals() {
  return dispatchPayloadAction(
    () => apiGet(Auth.getApiUrl() + '/leads/referrals'),
    (dispatch, response) =>
      dispatch({
        type: 'DISPLAY_REFERRALS',
        referrals: response.referrals,
      })
  );
}

export function createReferralLink(propertyId) {
  return (dispatch, getState) => {
    const referralLink = getState().tenantProfile.referralLinks[propertyId];
    if (referralLink) {
      return new Promise(resolve => {
        resolve(referralLink);
      });
    }

    // Only make call if we don't have a link for that property yet
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/leads/properties/${propertyId}/referral_link`)
        .done(response => {
          dispatch({
            type: 'DISPLAY_REFERRAL_LINK',
            referralLink: response.referral_link,
            propertyId,
          });
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function deleteTenantAssetDocument(assetId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/leads/asset_documents/${assetId}`).done(response => {
        dispatch(todoActions.getTenantTodoList());
        dispatch(downloadActions.getDocuments());
        dispatch(notifications.showSuccess('successfullyDeletedDocument'));
      }),
    }).catch(error => {
      dispatch(notifications.showFailure(error));
      console.error('request failed', error);
    });
  };
}

export function editTenantAssetDocument(assetId, expiryDate) {
  const data = {
    expiry_date: JSON.parse(JSON.stringify(expiryDate)),
  };
  return dispatch => {
    return dispatch({
      payload: apiPut(
        Auth.getApiUrl() + `/leads/asset_documents/${assetId}`,
        data
      ).done(response => {
        dispatch(todoActions.getTenantTodoList());
        dispatch(downloadActions.getDocuments());
        dispatch(notifications.showSuccess('successfullyUploadedDocument'));
      }),
    }).catch(error => {
      dispatch(notifications.showFailure(error));
      console.error('request failed', error);
    });
  };
}

export function createTenantDocument(data) {
  return dispatch => {
    // upload new tenant document
    const multiPartFormData = new FormData();
    multiPartFormData.append('file', data.new_document.file[0]);
    multiPartFormData.append('document_type', data.new_document.document_type);
    if (data.new_document.document_sub_type) {
      multiPartFormData.append('document_sub_type', data.new_document.document_sub_type);
    }

    if (data.renters_insurance_expiry_date) {
      multiPartFormData.append(
        'renters_insurance_expiry_date',
        toISO8601DateString(data.renters_insurance_expiry_date)
      );
    }

    if (data.renters_insurance_start_date) {
      multiPartFormData.append(
        'renters_insurance_start_date',
        toISO8601DateString(data.renters_insurance_start_date)
      );
    }

    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + '/leads/documents', multiPartFormData)
        .done(response => {
          if (browserHistory.getCurrentLocation().pathname === '/dashboard') {
            dispatch(todoActions.getTenantTodoList());
            dispatch(downloadActions.getDocuments());
          }
          dispatch(notifications.showSuccess('successfullyUploadedDocument'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

function saveAncillaryItems(ancillaryItems) {
  return {
    type: 'SAVE_ANCILLARY_ITEMS',
    ancillaryItems,
  };
}

export function createLeaseCharge(data) {
  const id = data.leaseItem.id;

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/leads/ancillary_items/${id}/lease_charges`, data)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyAddedLeaseItem'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getAncillaryItemPricing(id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/leads/ancillary_items/${id}/pricing`)
        .done(response => {
          const ancillaryItemPricing = {};
          Object.keys(response.pricing_breakdown).forEach(key => {
            ancillaryItemPricing[key.replace(/_/gi, ' ')] = response.pricing_breakdown[key];
          });

          dispatch({
            type: 'SAVE_ANCILLARY_ITEM_PRICING',
            ancillaryItemPricing,
          });
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getAncillaryItems() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/ancillary_items')
        .done(response => {
          dispatch(saveAncillaryItems(response.ancillary_items));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getBuildingCommunity() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/building_community')
        .done(response => {
          dispatch({
            type: 'TENANT_PROFILE::BUILDING_COMMUNITY',
            buildingCommunity: response.building_community,
          });
        })
        .catch((error, textStatus) => {
          console.error(textStatus);
        }),
    });
  };
}

export function getTenancyInfo() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/tenancy_info')
        .done(response => {
          dispatch({
            type: 'TENANT_PROFILE::TENANCY_INFO',
            tenancyInfo: response.tenancy_info || {},
          });
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function addForwardingAddress(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/forwarding_address')
        .done(response => {
          dispatch(notifications.showSuccess('successfullyAddedForwardingAddress'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deleteEmergencyContact(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/leads/emergency_contacts/${id}`).done(response => {
        dispatch(notifications.showSuccess('successfullyDeletedEmergencyContact'));
        dispatch(getTenantProfile());
      }),
    });
  };
}

export function makeRentPayment(paymentId, token, payment_type) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/leads/make_payment/${paymentId}`, {
        token,
        payment_type,
      })
        .done(response => {
          dispatch(notifications.showSuccess('weHaveSuccessfullyReceivedYourRentPayment'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function makeCustomAmountPayment(token, paymentAmount) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/leads/custom_amount_payment`, {
        token: token,
        payment_amount: paymentAmount,
      })
        .done(response => {
          dispatch(notifications.showSuccess('weHaveSuccessfullyReceivedYourRentPayment'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function createEmergencyContact(formData) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/emergency_contacts', formData)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyAddedEmergencyContact'));
          dispatch(getTenantProfile());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function editEmergencyContact(formData, id) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/leads/emergency_contacts/${id}`, formData)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyEditedEmergencyContact'));
          dispatch(getTenantProfile());
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function rsvpForEvent(siteEventid) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/leads/site_events/rsvp/${siteEventid}`)
        .done(response => {
          if (response.rsvp) {
            dispatch(notifications.showSuccess('weCantWait'));
            // confetti once we merge in the other PR
          } else {
            dispatch(notifications.showSuccess('rsvpSuccessfullyDeleted'));
          }
          dispatch(getBuildingCommunity());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function saveInitialUserPreference(formData, emailChanged = false) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/leads/initialize_tenant', formData)
        .done(response => {
          if (emailChanged) {
            dispatch(logUserOut());
            return;
          }
          dispatch(getUserPreferences());
          dispatch(hideInitialLeadDialog());
          dispatch(getTenantProfile());
          dispatch(notifications.showSuccess('preferencesSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
          throw Error;
        }),
    });
  };
}
